import { EngineeringApi, setAuthorizationAfterLogin } from '../clients/AxiosClients';

/**
 * Troca o id token do Entra ID (login MSAL) pelo jwt SmartForest que as APIs de recurso
 * exigem. A conta de serviço fica no servidor (Key Vault, via Engineering.API) — substitui
 * o workaround antigo que vivia editado direto no bundle do IIS.
 *
 * Grava o jwt no localStorage e atualiza os axios clients já criados.
 */
export const trocarTokenEntraPorJwtSmartForest = async (idToken) => {
    const response = await EngineeringApi.post('TokenExchange', null, {
        headers: { Authorization: `Bearer ${idToken}` }
    });

    // Tolerante ao wrapper de resposta da API ({ result: { token } } ou { token })
    const token = response.data?.result?.token ?? response.data?.token;
    if (!token)
        throw new Error('TokenExchange não retornou o token SmartForest');

    localStorage.setItem('jwt', token);
    setAuthorizationAfterLogin();
};
